import React from 'react'
import { useParams } from 'react-router-dom'
import { TABS, useDoc } from './doc.context'
import { useTheme } from '../../context/theme.context'
import Button from './comp/Button'
import Swal from 'sweetalert2'
import { useAgency } from '../../context/agency.context'

function TabItem({ active = false, label = '', onClick }: any) {
  const { brandings } = useTheme()

  return (
    <li
      onClick={onClick}
      className={`cursor-pointer text-sm font-medium transition-all duration-200 
        ${
          active
            ? 'text-blue-600 bg-white border border-gray-300 border-b-white rounded-t-md'
            : 'text-gray-600 hover:text-blue-600 border-b border-gray-200'
        } 
        px-4 py-2`}
      style={{
        borderBottom: active ? '1px solid white' : '1px solid #e5e7eb',
      }}
    >
      {label}
    </li>
  )
}

function Tabs() {
  const { agency } = useAgency()
  const { brandings } = useTheme()
  const { activeTab, setActiveTab } = useDoc()
  const { company_id, app_id } = useParams()

  const handleTab = (tab: string) => {
    setActiveTab(tab)
  }

  const copyCustomMenuLink = () => {
    if (!agency?.domain) {
      Swal.fire('Please configure your domain in settings')
      return
    }
    const text = `https://${agency?.domain}/${app_id}/${company_id}/documents`
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    Swal.fire('Copied to clipboard')
    document.body.removeChild(textarea)
  }

  return (
    <div className='p-4'>
      <div className='text-sm font-medium text-center relative'>
        <div
          className='absolute bottom-0 left-0 w-full h-[2px]'
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          }}
        ></div>

        <div className='flex items-center justify-between relative z-10 border-b border-transparent'>
          <ul className='flex space-x-1'>
            <TabItem
              label='Documents'
              onClick={() => handleTab(TABS.DOC)}
              active={activeTab === TABS.DOC}
            />
            <TabItem
              label='Editor'
              onClick={() => handleTab(TABS.EDITOR)}
              active={activeTab === TABS.EDITOR}
            />
            <TabItem
              label='Settings'
              onClick={() => handleTab(TABS.SETTING)}
              active={activeTab === TABS.SETTING}
            />
          </ul>
          <div>
            <Button onClick={copyCustomMenuLink}>Copy Custom Menu Link</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tabs
